import { InterfaceMapBox } from 'components/MapboxMap/types'
import React, { useContext, useEffect, useState } from 'react'
import { MapContext } from '../MapboxMap'

import './styles.scss'

interface Props {
  isMobile: boolean
  hazards: { name: string; id: string; color: string }[]
}

export const HazardLayerSwitch = ({ hazards, isMobile }: Props) => {
  const map = useContext(MapContext)
  const [hiddenHazards, setHiddenHazards] = useState<string[]>([])
  const toggleHazards = (e: React.MouseEvent) => {
    if (!e.nativeEvent.target || !map?.loaded()) return
    let hazard = e.nativeEvent.target.id
    let newHidden = [...hiddenHazards]
    if (newHidden.length === 0) {
      newHidden = hazards.map(m => m.id).filter(item => item !== hazard)
    } else if (newHidden.length === 3) {
      if (newHidden.indexOf(hazard) === -1) {
        newHidden = []
      } else {
        newHidden = hazards.map(m => m.id).filter(item => item !== hazard)
      }
    }
    setHiddenHazards(newHidden)
  }

  const showAndHideHazards = () => {
    if (!map) return
    let layers = map.getStyle().layers
    layers=layers.slice(50)
    console.log(layers)

    hazards.forEach((hazard: { name: string; id: string; color: string }) => {
      layers?.map(l => {
        if (l.id.includes('_' + hazard.id)) {

          if (!hiddenHazards.includes(hazard.id)) {
            if (
              !l.id.includes('peri_' + hazard.id) ||
              hiddenHazards.length === 3
            ) {
              map.setLayoutProperty(l.id, 'visibility', 'visible')
            } else {
              map.setLayoutProperty(l.id, 'visibility', 'none')
            }
          } else {
            map.setLayoutProperty(l.id, 'visibility', 'none')
          }
        }
      })
    })
  }
  // Show and Hide Hazard-Layers
  useEffect(() => {
    if (!map || !map.loaded()) return
    showAndHideHazards()
  }, [hiddenHazards])

  return (
    <div className='hazardswitchcontainer'>
      {map &&
        hazards.map((h, i) => (
          <button
            key={i}
            id={h.id}
            onClick={toggleHazards}
            style={{
              backgroundColor: h.color
            }}
            className={`hazardswitch ${h.id} 
            ${hiddenHazards.indexOf(h.id) !== -1 ? 'off' : ''}`}
          >
            <img src={require('images/icons_' + h.id + '.svg')} />
            {(!isMobile ||
              (hiddenHazards.indexOf(h.id) === -1 &&
                hiddenHazards.length === 3)) && <div>{h.name}</div>}
          </button>
        ))}
    </div>
  )
}
